<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="来源分类">
              <a-select show-search option-filter-prop="children" v-model="queryParams.uomClassList" mode="multiple" :max-tag-text-length="2" :max-tag-count="2">
                <a-select-option v-for="(item) in uomClassOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="来源单位">
              <a-select show-search option-filter-prop="children" v-model="queryParams.unitOfMeasureList" mode="multiple" :max-tag-text-length="2" :max-tag-count="2">
                <a-select-option v-for="(item) in unitOfMeasureList" :key="item.realValue">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="基本单位">
              <a-select show-search option-filter-prop="children" v-model="queryParams.baseUomList" mode="multiple" :max-tag-text-length="2" :max-tag-count="2">
                <a-select-option v-for="(item) in unitOfMeasureListNew" :key="item.realValue">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select show-search option-filter-prop="children" v-model="queryParams.status" allowClear>
                  <a-select-option v-for="(item) in statusOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apidMUomConversionsNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['mdm:mdmUomConversions:add']">新增</a-button>
      <a-button @click="handleExport" v-hasPermi="['mdm:mdmUomConversions:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.STANDARD_UNIT_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="conversionRate" slot-scope="{ record }">
            <a-popover>
              <template slot="content">
                <p>即换算比例，1*折换*来源单位=1*基本单位</p>
              </template>
              <span v-if="!isEdit || currentId !== record.id">{{ record.conversionRate }}</span>
              <a-input-number v-if="isEdit && currentId === record.id" v-model="record.conversionRate" :min="0" size="small" @blur="blur(record)" />
            </a-popover>
          </template>
          <template slot="conversionRateInverse" slot-scope="{ record }">
            <a-popover>
              <template slot="content">
                <p>即换算比例倒数，1*倒数*来源单位=1*基本单位</p>
              </template>
              <span>{{ record.conversionRateInverse }}</span>
            </a-popover>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="status" slot-scope="{ record }">
            <a-switch :disabled="!isEdit || currentId !== record.id" :checked="record.status === 'Y'" @change="statusOnChange(record)" />
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['mdm:mdmUomConversions:edit']">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
        <standard-unit-add
          ref="createModal"
          :uomClassOptions="uomClassOptions"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiMdmUomConversionsList, apiMdmUomConversionsUpdate, apiMdmUomUnitsOfMeasureUnitOfMeasureList, apidMUomConversionsNewExport } from '@/api/mdm/units/standard-unit'
import StandardUnitAdd from './components/standard-unit-add'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
export default {
  name: 'StandardUnit',
  components: {
    DownloadModal,
    StandardUnitAdd
  },
  data () {
    return {
      apidMUomConversionsNewExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMdmUomConversionsList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        uomClassList: undefined,
        unitOfMeasureList: undefined,
        baseUomList: undefined,
        status: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 状态快码
      statusOptions: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 表格字段
      columns: [
        {
          title: '来源分类',
          dataIndex: 'uomClass',
          align: 'center',
          width: 100
        },
        {
          title: '来源单位',
          dataIndex: 'unitOfMeasure',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '折换',
          dataIndex: 'conversionRate',
          width: 120,
          scopedSlots: { customRender: 'conversionRate' },
          align: 'center'
        },
        {
          title: '倒数',
          dataIndex: 'conversionRateInverse',
          scopedSlots: { customRender: 'conversionRateInverse' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '基本单位',
          dataIndex: 'baseUnitOfMeasure',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '最后修改人',
          dataIndex: 'updateName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      uomClassOptions: [], // 来源分类
      unitOfMeasureList: [], // 来源单位
      unitOfMeasureListNew: [] // 基本单位
    }
  },
  created () {
    this.getUnitOfMeasureList()
    const lookupQueryParams = {
      lookupType: 'MDM_UOM_CLASSES',
      current: 1,
      pageSize: 100
    }
    this.getLookupListData(lookupQueryParams).then().then(response => {
      this.uomClassOptions = response.rows
    })
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 列表-折换字段
    blur (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
      } else {
        record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
      }
    },
    statusOnChange (record) {
      record.status = record.status === 'Y' ? 'N' : 'Y'
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('mdm/mdmUomConversions/export', {
      //   ...this.queryParams
      // }, `标准单位转换_${new Date().getTime()}.xlsx`)
    },
    getUnitOfMeasureList () {
      apiMdmUomUnitsOfMeasureUnitOfMeasureList().then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.unitOfMeasureList = res.data;
        }
      })
      apiMdmUomUnitsOfMeasureUnitOfMeasureList({ baseUomFlag: 'Y', status: 'Y' }).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          this.unitOfMeasureListNew = res.data;
        }
      })
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
        return
      }
      apiMdmUomConversionsUpdate(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
          this.isEdit = false;
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        uomClassList: undefined,
        unitOfMeasureList: undefined,
        baseUomList: undefined,
        status: undefined
      }
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
</style>
